import axios from 'axios';
import { PresignedUrl } from 'commons/types';

export async function uploadFileToS3(
  fileStream: File,
  { url, fields }: PresignedUrl,
): Promise<void> {
  // normalize keys to the ones S3 expects (don't use CamelCase)
  const keyMap: Record<string, string> = {
    xAmzAlgorithm: 'x-amz-algorithm',
    xAmzCredential: 'x-amz-credential',
    xAmzDate: 'x-amz-date',
    xAmzSignature: 'x-amz-signature',
    xAmzSecurityToken: 'x-amz-security-token',
    contentType: 'Content-Type',
    'Content-Type': 'Content-Type',
  };
  const form = new FormData();
  for (const [k, v] of Object.entries(fields)) {
    const mapped = keyMap[k] ?? k;
    // don't send bucket
    if (mapped !== 'bucket') form.append(mapped, v);
  }

  if (!fields['Content-Type'] && !fields['contentType']) {
    form.append('Content-Type', fileStream.type);
  }
  form.append('file', fileStream, fileStream.name);
  await axios.post(url, form);
}
